


























/* eslint-disable @typescript-eslint/no-empty-function */
import Vue from 'vue'
import { mapState } from 'vuex'
import store from '@/store'

export default Vue.extend({
    name: 'App',
    data: () => ({
        unsubscribe: () => {},
    }),
    computed: {
        showPersistentNotif: {
            get() {
                return !!this.persistentNotif
            },
            set(open: boolean) {
                if (!open) {
                    store.dispatch('notification/deletePersistent')
                }
            },
        },
        ...mapState('user', ['user']),
        ...mapState('notification', ['persistentNotif', 'popupNotifs']),
    },
    created() {
        this.unsubscribe = this.$store.subscribe((mutation) => {
            const expireDate = new Date()
            expireDate.setFullYear(expireDate.getFullYear() - 3)
            if (
                mutation.type === 'user/ADDUSER' &&
                (!this.user.updatedAt || this.user.updatedAt < expireDate) &&
                this.$route.name !== 'NotFound'
            ) {
                console.log(this.user.name, 'The account is outdated or logged in first time.')
                if (this.$route.name !== 'ProfileEdit') {
                    this.$router.push('/profile/edit')
                }
                store.dispatch('notification/addPersistent', {
                    message: this.$i18n.t('profileUpdateNotif'),
                    type: 'info',
                })
            }
        })
    },
    beforeDestroy() {
        this.unsubscribe()
    },
})
